module.exports = __webpack_public_path__ + "static/media/anexo.5f8365f8.svg";